/*更新 access_token*/
export const UPDATE_ACCESS_TOKEN = "updateAccessToken";
/*更新 refresh_token*/
export const UPDATE_REFRESH_TOKEN = "updateRefreshToken";
/*清空 token*/
export const CLEAR_TOKEN = "clearToken";
/*申请提高权限*/
export const UPGRADE_PRIVILEGE = "upgradePrivilege";
/* 更新权限 */
export const PRIVILEGE = "privilege";
/*更新本地 markdown 存储*/
export const UPDATE_LOCAL_MARKDOWN = "updateLocalMarkdown";
/*移除本地 markdown 存储*/
export const REMOVE_LOCAL_BLOG = "removeLocalBlog";
/*更新是否绑定微信状态*/
export const UPDATE_BIND_WECHAT = "updateBindWechat";
/*更新搜索词*/
export const UPDATE_SEARCH_WORDS = "updateSearchWords";


/*更换头像*/
export const UPDATE_AVATAR = "updateAvatar";
/*是否开启短信校验身份*/
export const UPDATE_SMS_CAPTCHA_ABLE = "updateSmsCpatchaAble";
/*更新缺省校验方式*/
export const UPDATE_SAFETY_CHECK_MODE = "updateSafetyCheckMode";
/*修改 markdown 主题*/
export const UPDATE_MARKDOWN_THEME = "updateMarkdownTheme";

